import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as serviceWorker from './serviceWorker';
/*import Favicon from 'react-favicon';*/
import "typeface-montserrat";
import './fonts/DejaVuSerif/DejaVuSerif.ttf'
import './fonts/DejaVuSerif/DejaVuSerif-Bold.ttf'
import './fonts/Roboto/Roboto-Regular.ttf'
import Axios from 'axios'
import { createStore, combineReducers } from "redux";
import { Provider } from "react-redux";
import { HashRouter } from 'react-router-dom'

import user from './store.js'

import client from './User/store'
import clientSettings from './User/components/Settings/store.js'
import clientRacuni from './User/components/Racuni/store.js'
import clientIzvjestaji from './User/components/Izvjestaji/store.js'
import adminClient from './Admin/components/Client/store.js'


Axios.defaults.baseURL = process.env.REACT_APP_BASE_URL

const rootReducer = combineReducers({ 
	user: user,
	client: client,
	clientSettings: clientSettings,
	clientRacuni: clientRacuni,
    clientIzvjestaji: clientIzvjestaji,
    adminClient: adminClient
});

const store = createStore(rootReducer);

ReactDOM.render(
	<Provider store={store}>
		<HashRouter basename={"/"}>
			<App />  
		</HashRouter>
	</Provider>,
	document.getElementById('root')
);

serviceWorker.unregister();
